<template>
  <div class="promo-input-wrapper">
    <h6>Apply Coupon Code</h6>
    <form data-vv-scope="applyPromoCard">
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          id="promoCodeFormCodeInput"
          aria-describedby="emailHelp"
          placeholder="Coupon Code"
          name="promoCode"
          v-model="promoCode"
          v-validate="'required'"
          :class="(showApplyPromoCardError &&
                   errors.has('applyPromoCard.promoCode')) || !isValid?'is-invalid':''"
          data-test="promoCodeFormCodeInput"
        />
      </div>
      <button type="submit"
              class="btn btn-primary btn-type-primary"
              @click.prevent="action('applyPromoCard')"
              data-test="promoCodeFormApplyBtn"
              id="promoCodeFormApplyBtn"
      >
        Apply
      </button>
    </form>
    <div
      class="invalid-feedback"
      v-if="(errors.has('applyPromoCard.promoCode') && showApplyPromoCardError) || !isValid"
      style="display: block;"
      id="promo-code-email-error"
      data-test="promoCodeFormCodeInputError"
    >{{ !isValid?'Coupon Code is not Valid':errors.first('applyPromoCard.promoCode') }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { productApi } from '../../../../services/ApiServices/productApi'
import { store } from '../../../../store/store'

export default {
	name: 'PromoCodeForm',
	data () {
		return {
			showApplyPromoCardError: false,
			promoCardValidationData: {
				promoCardNumber: '',
				promoCardPin: ''
			},
			promoCode: '',
			isValid: true
		}
	},
	beforeMount () {
		store.dispatch('user/setPromoCodeData', '')
	},
	computed: {
		...mapGetters('cart', ['getcartTotal']),
		...mapGetters('buynow', ['getBuyNowProduct'])
	},
	methods: {
		...mapActions('cart', ['updateGiftCardCartQuantity']),
		...mapActions('buynow', ['updateGiftCardQuantity']),
		action (scope) {
			this.$validator.validateAll(scope).then((result) => {
				if (result) {
					this.showApplyPromoCardError = false
					this.verifyPromo(this.promoCode)
				} else {
					this.showApplyPromoCardError = true
				}
			})
		},
		clearForm () {
			this.promoCode = ''
			this.isValid = true
		},
		// beforeDestroy() {
		//   store.dispatch('user/setPromoCodeData', '');
		// },
		async verifyPromo () {
			await productApi.verifyPromoCode(this.promoCode).then((res) => {
				if (res.status === 200 && res.data && res.data.quantity && res.data.quantity > 0) {
					this.isValid = true
					if (this.getBuyNowProduct.length > 0) {
						this.updateGiftCardQuantity()
					} else {
						this.updateGiftCardCartQuantity()
					}
					this.$toasted.show('Coupon Code Applied Successfully')
					$('#collapsegiftapply').collapse('hide')
				} else {
					this.isValid = false
					this.$toasted.show('Coupon Code is not Valid')
				}
			}).catch((err) => {
				if (err.status === 400) {
					this.isValid = false
				}
			})
		}
	}
}
</script>
